import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, Stack, Typography } from '@mui/material';
import ImageListItem from '@mui/material/ImageListItem';

import BackgroundImage from '../../shared/image/placeholder.jpg';

import './index.scss';
import Wysiwyg from '../shared/Wysiwyg';
import { Link } from 'react-router-dom';
import {
  imageCardImageFrameSx,
  imageCardSurfaceSx,
  imageCardTextSectionSx,
} from './imageCardChromeSx';

function ImageCard({ item={}, url, topHeading = null, footerAction = null, imageBackground = '#fff', imageFit = 'cover' }) {

  const retailer = useSelector(state => state.retailer);
  
  const placeholderImage = retailer.default_image ?
  `${process.env.REACT_APP_API_URL}/assets/${retailer.default_image}`
  : BackgroundImage;
  
  const imageTransformationKey = item?.url?.includes('key') ? '' : '?key=brand-portal-image-card-square';

  const [imageSource, setImageSource] = useState(`${item.url || placeholderImage}${imageTransformationKey}`);

  const CardContainer = ({ children }) => (
    url ? (
      <Link to={url}>
        {children}
      </Link>
    ) : <>{children}</>
  )

  return (
    <Box
      sx={{
        ...imageCardSurfaceSx,
        pb: footerAction ? '60px' : 'inherit',
      }}
    >
      <CardContainer>
        <ImageListItem key={item.url}
          sx={{
            height: '100%',
            width: '100%',
          }}
        >
          {topHeading &&
            <Stack sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 300, color: '#090909', fontSize: '16px', textTransform: 'uppercase', whiteSpace: 'nowrap', overflow: 'hidden' }}>{topHeading}</Typography>
            </Stack>
          }

          <Box
            sx={{
              ...imageCardImageFrameSx,
              background: imageBackground,
            }}
          >
            <img
              className='card-image'
              src={imageSource}
              srcSet={imageSource}
              loading="lazy"
              onError={(event) => { setImageSource(placeholderImage) }}
              style={{
                objectFit: imageFit,
                objectPosition: 'center',
                width: '100%',
                height: '100%',
              }}
            />
          </Box>

          <Box sx={imageCardTextSectionSx}>
            {!!item.title && 
              <Box sx={{ my: 1 }}>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    color: '#090909',
                    fontSize: '0.9rem',
                    textTransform: 'capitalize',
                    textDecoration: 'none',
                  }}
                  component="div"
                >
                  <Wysiwyg
                    truncateAfterLine={2}
                  >
                    {item.title}
                  </Wysiwyg>
                </Typography>
              </Box>
            }

            {!!item.description && 
              <Box sx={{ my: 0 }}>
                <Typography
                  sx={{
                    fontWeight: 300,
                    color: '#090909',
                    fontSize: '0.8rem'
                  }}
                  component="div"
                >
                  <Wysiwyg
                    truncateAfterLine={2}
                  >
                    {item.description}
                  </Wysiwyg>
                </Typography>
              </Box>
            }
          </Box>
        </ImageListItem>
      </CardContainer>

      {
        footerAction ?
          <Box
            sx={{
              position: 'absolute',
              bottom: '12px',
              left: '16px',
              right: '16px',
            }}
          >
            {footerAction}
          </Box>
        :
          <Box
            sx={{
              height: '1rem',
            }}
          />
      }
    </Box>
  );
}

export default ImageCard